import { AsyncPipe, TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { Language, LanguageService } from '@core/services/language/language.service';
import { StorageKey, StorageService } from '@core/services/storage/storage.service';
import { DropdownMenuComponent } from '@ui/dropdown-menu/dropdown-menu.component';
import { MenuItem } from '@shared/model/menu-item.type';
import { ModalService } from '@shared/services/modal.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss'],
  imports: [DropdownMenuComponent, MatMenuModule, AsyncPipe, TitleCasePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSwitcherComponent {
  private readonly languageService = inject(LanguageService);
  private readonly modalService = inject(ModalService);

  protected readonly currentLang$: Observable<string> = this.languageService.currentLang.asObservable();
  protected readonly Language: typeof Language = Language;

  languageMenuItems: MenuItem[] = LanguageService.languageKeys.map((languageKey) => ({
    label: this.Language[languageKey],
    click: () => this.openConfirmationModal(languageKey),
  }));

  openConfirmationModal(languageKey: string): void {
    if (this.languageService.currentLang.getValue() === languageKey) {
      return;
    }
    this.modalService.openConfimationModal({
      header: 'core.header.confirmationChangeLanguage',
      data: 'core.header.warningChangeLanguage',
      confirmAction: async () => {
        StorageService.set(StorageKey.Language, languageKey);
        window.location.reload();
      },
    });
  }
}
